import {createReducer, on} from '@ngrx/store';
import {DubletteNoticeDialogState} from '../states/dublette-notice-dialog.state';
import {DubletteNoticeDialogActions} from '../actions/dublette-notice-dialog.actions';

export const initialDubletteNoticeDialogState: DubletteNoticeDialogState = {
  isOpen: false,
};

export const dubletteNoticeDialogReducer = createReducer(
  initialDubletteNoticeDialogState,

  on(DubletteNoticeDialogActions.open, (state, {intent}) => ({
    ...state,
    isOpen: true,
    intent,
  })),

  on(DubletteNoticeDialogActions.close, () => ({
    ...initialDubletteNoticeDialogState,
  })),
);
